import { cn } from "@/lib/cn";

import full from "@/assets/stokkie-logo.webp";
import small from "@/assets/stokkie-logo-small.webp";

/**
 * Stokkie Stokvel — Market Place Konnect: the stokvel portal's own name and mark.
 *
 * Two sizes of the same artwork, chosen by the browser, so a header on a
 * prepaid phone downloads 14 KB rather than the 43 KB the website's hero needs.
 * The artwork carries its own white ground, so it sits on white surfaces.
 */
export function StokkieLogo({ className }: { className?: string }) {
  return (
    <img
      src={small}
      srcSet={`${small} 420w, ${full} 960w`}
      sizes="(min-width: 640px) 480px, 90vw"
      alt="Stokkie Stokvel Market Place Konnect"
      className={cn("h-auto w-auto", className)}
    />
  );
}
